import { render, staticRenderFns } from "./_preference-pages.vue?vue&type=template&id=89215f04"
import script from "./_preference-pages.vue?vue&type=script&lang=js"
export * from "./_preference-pages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports